import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const CheckboxTextStyled = styled.span`
  font-size: 1.4rem;
  text-transform: uppercase;
`;

export const SelectedAllBlockStyled = styled.div<{ $isDisabled?: boolean }>`
  & svg {
    margin: 0;
    width: 2rem;
  }

  & label {
    align-items: center;
  }
`;

export const BatchSectionStyled = styled.section`
  border-top: 0.1rem solid ${colors.neutral[300]};
  border-bottom: 0.1rem solid ${colors.neutral[500]};
  background-color: ${colors.neutral.white};
  padding: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonStyled = styled(Button)`
  text-transform: uppercase;
`;

export const BatchButtonsStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  position: relative;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const SectionTitleStyled = styled.b`
  min-width: 16rem;
  font-size: 1.4rem;
  line-height: 2rem;
  text-transform: uppercase;
`;
